import type { MutableRefObject, RefObject } from 'react';
import { parentHasClass } from './dom/parentHasClass';

export type OnClickOutsideOptions = {
    ref?: RefObject<HTMLElement>;
    triggerOnRightClick?: boolean;
    excludedClasses?: string[];
    createExcludedClass?: boolean;
    excludedElements?: HTMLElement[];
};

const callbacks: ((e: MouseEvent) => void)[] = [];
let mouseDownListener: ((e: MouseEvent) => void) | undefined;

export const onClickOutside = (
    el:
        | MutableRefObject<HTMLElement | undefined | null>
        | RefObject<HTMLElement | undefined | null>,
    cb: (e: MouseEvent) => void,
    options: OnClickOutsideOptions = {}
) => {
    if (!callbacks.length) {
        mouseDownListener = (e) => {
            callbacks.forEach((cb) => cb(e));
        };
        document.addEventListener('mousedown', mouseDownListener);
    }

    const isExcluded = (target: HTMLElement) => {
        const excludedClasses = (options && options.excludedClasses) || [];
        if (
            options.excludedElements &&
            (options.excludedElements.includes(target) ||
                options.excludedElements.find((el) => el.contains(target)))
        )
            return true;
        if (!excludedClasses.length) return false;
        return parentHasClass(target, excludedClasses);
    };

    const onClickOutside = (e: MouseEvent) => {
        const button = e.button;
        if (button <= 1 || options.triggerOnRightClick) {
            if (!el.current || el.current.contains(e.target as HTMLElement)) return;
            if (!isExcluded(e.target as HTMLElement)) {
                cb(e);
            }
        }
    };

    callbacks.push(onClickOutside);
    return () => {
        callbacks.splice(callbacks.indexOf(onClickOutside), 1);
        if (callbacks.length === 0 && mouseDownListener) {
            document.removeEventListener('mousedown', mouseDownListener);
        }
    };
};
